// @description — Тип авторов. \n\r\n1 - Исполнитель \n\r\n2 - Подкастер \n\r\n3 - Проповедник \n\r\n4 - Чтец \nВозможные значения:\n\n1 - Artist: Исполнитель.\n2 - Podcaster: Подкастер.\n3 - Preacher: Проповедник.\n4 - Reader: Чтец.\n\n
import { type AuthorTypeEnumEnum } from '@/shared/api'

export const AuthorTypeEnum = {
  Artist: 1,
  Podcaster: 2,
  Preacher: 3,
  Reader: 4,
} as const satisfies Record<string, AuthorTypeEnumEnum>

export type AuthorTypeEnum =
  (typeof AuthorTypeEnum)[keyof typeof AuthorTypeEnum]

export const authorTypeArray = Object.values(AuthorTypeEnum)

export type AuthorTypeString =
  | 'Исполнитель'
  | 'Подкастер'
  | 'Проповедник'
  | 'Чтец'
  | 'Неизвестный тип'

const authorTypeStringsMap: Record<AuthorTypeEnum, AuthorTypeString> = {
  [AuthorTypeEnum.Artist]: 'Исполнитель',
  [AuthorTypeEnum.Podcaster]: 'Подкастер',
  [AuthorTypeEnum.Preacher]: 'Проповедник',
  [AuthorTypeEnum.Reader]: 'Чтец',
}

export const getAuthorTypeString = (type: number): AuthorTypeString => {
  return authorTypeStringsMap[type as AuthorTypeEnum] ?? 'Неизвестный тип'
}
